import { kindList } from '@/api/office/contract-manage/index.js'
import { getEmployeePage } from '@/api/office/employee.js'

const contractManage = {
  state: {
    kindClass: [],
    employeeList: []
  },
  mutations: {},
  actions: {
    // 获取合同分类
    async getKindList({ state, commit }, payload) {
      const { code, data } = await kindList()
      if (code !== 0 || !Array.isArray(data)) {
        return
      }
      data.unshift({
        id: '',
        kindName: '全部',
        kindCode: 'QB'
      })
      state.kindClass = data
    },
    // 获取员工
    async getEmployeeList({ state, commit }, payload) {
      const param = {
        current: 1,
        size: 1000,
        status: [1, 2, 3]
      }
      const { code, data } = await getEmployeePage(param)
      if (code !== 0) {
        return
      }
      data.records.forEach((it) => {
        it.label = it.name
        it.value = it.accountId
      })
      state.employeeList = data.records
    }
  }
}

export default contractManage
